import { Brick, registerBrick } from 'olympe';

export default class CalculatePositionBasedOnHiddenFields extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {boolean} alternativeDDGroupHidden
     * @param {boolean} vendorDetailsGroupHidden
     * @param {function(number)} setYRemarks
     * @param {function(number)} setYButton
     */
    update($, [alternativeDDGroupHidden, vendorDetailsGroupHidden], [setYRemarks, setYButton]) {
      if (alternativeDDGroupHidden && vendorDetailsGroupHidden) {
        setYRemarks(497);
        setYButton(620);
      } else if (alternativeDDGroupHidden && !vendorDetailsGroupHidden) {
        setYRemarks(680);
        setYButton(783);
      } else if (!alternativeDDGroupHidden && vendorDetailsGroupHidden) {
        setYRemarks(570);
        setYButton(693);
      } else {
        setYRemarks(790);
        setYButton(913);
      }
    }
}

registerBrick('0198e0696d0238cf673f', CalculatePositionBasedOnHiddenFields);
